<template lang="pug">
.reunion
  .push-top(v-if="!locateAcess")
  .main(:style="{height: (locateAcess?'100%':'calc(100% - 0.4rem)')}")
    .header
      common-header(
        title="",
        ref="header",
        :left-black-when-inactive="false"
      )
      .safe-area(v-if="isEasyBikeApp")
      .location-push(v-if="!locateAcess" @click="openSetting")
        .location-info 开启定位权限，查看附近的找寻信息
        button.open-location 去开启
    .content(:style="getLocateStyle")
      img(
        v-if="currentTab === 1"
        src="https://m.hellobike.com/resource/helloyun/12399/9csBD_tab-finding.png?x-oss-process=image/quality,q_80"
        style="width: 3.43rem;height: 0.36rem"
      )
      img(
        v-if="currentTab === 0"
        src="https://m.hellobike.com/resource/helloyun/12399/7pNRc_tab-found.png?x-oss-process=image/quality,q_80"
        style="width: 3.43rem; height: 0.36rem"
      )
      .init-data(v-if="loading")
        .nodata-info 正在努力加载中......
      template(v-if="!loading")
        .list-content(v-if="list.length > 0")
          .case-list(v-if="currentTab === 0" v-for="(item, index) in list")
            finding-item(
              :detail="item"
              :key="index"
            )
            .divider(v-if="index < list.length-1")
          .case-list(v-if="currentTab === 1" v-for="(item, index) in list")
            has-found-item(
              :detail="item"
              :key="index"
            )
            .divider(v-if="index < list.length-1")
        .no-list(v-else)
          .found-empty(v-if="currentTab === 0")
            img(
              src="https://m.hellobike.com/resource/helloyun/12399/ee97A_empty.png?x-oss-process=image/quality,q_80"
              style="width: 1.91rem;height: 1.5rem"
            )
            .found-empty-text 近期无走失儿童，海清河晏，共同守护
          .found-empty(v-else)
            img(
              src="https://m.hellobike.com/resource/helloyun/12399/ee97A_empty.png?x-oss-process=image/quality,q_80"
              style="width: 1.91rem;height: 1.5rem"
            )
            .found-empty-text 附近暂无相关信息，灯火尤在，一起守望
    .find-tab(
      :style="{top: (locateAcess?'2.03rem':'2.37rem')}"
    )
      .left-tab(v-if="currentTab === 1" @click="toggleTab")
      .right-tab(v-if="currentTab === 0" @click="toggleTab")
    //- .back-click(
    //-   :style="{top: (locateAcess?'0.8rem':'1.16rem')}"
    //-   @click="goThemePage"
    //- )
</template>

<script>
/* eslint-disable max-len */
import { Native, env } from '@hb/NBridge/lib/h5';
// import { isPreRender, commonGoLink } from '@/utils';
import { isPreRender } from '@/utils';
import Toast from '@/components/toast';
import { getCaseList } from '@/api/reunion';
import CommonHeader from '@/components/common-header';
import { UBTUtils } from '../../utils/ubt';
import findingItem from './components/findingItem.vue';
import hasFoundItem from './components/hasFoundItem.vue';

export default {
  components: {
    findingItem,
    hasFoundItem,
    CommonHeader,
  },
  data() {
    return {
      list: [],
      currentTab: 0,
      loading: false,
      locateAcess: true,
    };
  },
  computed: {
    isEasyBikeApp() {
      if (env.isEasyBikeApp) {
        return true;
      }
      return false;
    },
    getLocateStyle() {
      if (this.locateAcess) {
        return {
          top: '2.03rem',
          height: 'calc(100% - 2.43rem)',
        };
      }
      return {
        top: '2.37rem',
        height: 'calc(100% - 2.79rem)',
      };
    },
  },
  mounted() {
    if (isPreRender()) {
      document.dispatchEvent(new Event('render-event'));
      return;
    }
    this.getNearList();
    UBTUtils.pageView({
      pageId: 'platform_tuanyuan_list',
      categoryId: 'platform',
      businessInfo: {},
    });
  },
  beforeDestroy() {
    UBTUtils.pageViewOut({
      pageId: 'platform_tuanyuan_list',
      categoryId: 'platform',
      businessInfo: {},
    });
  },
  methods: {
    back() {
      if (env.isEasyBikeApp) {
        Native.goBack();
      } else {
        this.$router.go(-1);
      }
    },
    async getNearList() {
      const cityData = await Native.getCityInfo();
      if (!cityData.longitude || !cityData.latitude) {
        this.locateAcess = false;
        return;
      }
      this.locateAcess = true;
      const {
        longitude: lng, latitude: lat,
      } = cityData;
      const parmas = {
        status: this.currentTab ? 'Closed' : 'New',
        lng,
        lat,
        // lng: '121.363928',
        // lat: '31.123356',
      };
      try {
        this.loading = true;
        const res = await getCaseList(parmas);
        if (res.data) {
          this.list = res.data;
          if (this.list.length > 0) {
            UBTUtils.moduleExpose({
              pageId: 'platform_tuanyuan_list',
              categoryId: 'platform',
              moduleId: 'platform_tuanyuan_click_case',
              contentId: 'platform_tuanyuan_click_case',
              exposureTimes: 1,
              businessInfo: {},
            });
          }
        }
      } catch (ex) {
        Toast.showError(ex);
      } finally {
        this.loading = false;
      }
    },
    toggleTab() {
      this.currentTab = 1 - this.currentTab;
      this.getNearList();
    },
    openSetting() {
      let method = '';
      if (env.isIOS) {
        method = 'goSetting';
      } else if (env.isAndroid) {
        method = 'openSystemSettingPage';
      }
      Native.callNative({
        method,
        classMap: 'business/user',
        params: {},
        timeout: false,
      });
    },
  },
};
</script>

<style lang="less" scoped>
.reunion {
  width: 3.75rem;
  height: 100%;
  background: #f7f7f7;

  .push-top {
    background: #0c8ae5;
    height: 0.36rem;
  }

  .main {
    width: 100%;

    .header {
      height: 3.27rem;
      width: 3.75rem;
      background: url("https://m.hellobike.com/resource/helloyun/12399/M8is2_back.png?x-oss-process=image/quality,q_80") no-repeat top;
      background-size: 100% 100%;

      .safe-area {
        padding-top: constant(safe-area-inset-top);
        padding-top: env(safe-area-inset-top);
        height: 0.4rem;
        background: #0c8ae5;
      }

      .location-push {
        position: absolute;
        width: 3.43rem;
        height: 0.375rem;
        background: #fef4e7;
        border-radius: 8px;
        left: 0;
        right: 0;
        margin: auto;
        display: flex;
        align-items: center;

        .location-info {
          position: relative;
          left: 0.16rem;
          height: 0.2rem;
          font-size: 0.14rem;
          font-family: PingFangSC-Regular, PingFang SC, sans-serif;
          font-weight: 400;
          color: #ff5526;
          line-height: 0.2rem;
        }

        .open-location {
          position: absolute;
          right: 0.12rem;
          width: 60px;
          height: 24px;
          background: #ff5526;
          border-radius: 12px;
          font-size: 12px;
          font-family: PingFangSC-Medium, PingFang SC, sans-serif;
          font-weight: 500;
          color: #fff;
          line-height: 12px;
        }
      }
    }

    .content {
      background: #fff;
      position: absolute;
      width: 3.42rem;
      left: 0;
      right: 0;
      margin: auto;
      border-radius: 12px 12px 0 0;

      .no-list {
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #fff;

        .found-empty {
          text-align: center;

          .found-empty-text {
            margin-top: 0.14rem;
            height: 20px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC, sans-serif;
            font-weight: 400;
            color: #242729;
            line-height: 20px;
          }
        }
      }

      .list-content {
        height: 100%;
        overflow: scroll;
        background: #fff;

        .divider {
          height: 0.01rem;
          border: 0.01rem solid #e1e6eb;
          transform: scaleY(0.5);
          margin: 0 0.15rem 0.01rem 0.17rem;
          background: #fff;
        }
      }

      .init-data {
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;

        .nodata-info {
          text-align: center;
        }
      }
    }
  }

  .find-tab {
    position: absolute;
    height: 0.34rem;
    width: 3.46rem;
    left: 0;
    right: 0;
    margin: auto;
    opacity: 0;

    .left-tab {
      float: left;
      width: 1.71rem;
      height: 0.34rem;
    }

    .right-tab {
      float: right;
      width: 1.71rem;
      height: 0.34rem;
    }
  }

  // .back-click {
  //   position: absolute;
  //   height: 1.2rem;
  //   width: 100%;
  //   left: 0;
  //   right: 0;
  //   margin: auto;
  //   opacity: 0;
  // }
}
</style>
